
import {  AppBar, Box, Fade, LinearProgress, Typography } from "@mui/material";
import React from "react";
import { StatusEnum } from "../../common/IExportNotificationMsg";
import { ProgressStateItem, useProgressContext } from "../../contexts/progress-context/ProgressContext";

type ProgressData = {
    percentComplete: number | undefined,
    buffer: number,
    message: string
};


export type ProgressIndicatorProps = {
    showTemporary: boolean
};

export default function ProgressIndicator({showTemporary}: ProgressIndicatorProps) {

    const [progressState] = useProgressContext();

    const getData = (item: ProgressStateItem): ProgressData => {

        const title = item?.title;
        const percentComplete = item?.notificationMsg.status === StatusEnum.Completed ? 
                                        100 : 
                                        (item?.notificationMsg.percentComplete ?? 0) >= 100 ? 
                                        80 : 
                                        item?.notificationMsg.percentComplete;
    
        const buffer = percentComplete ?  (percentComplete + (Math.random() * 10) + (Math.random() * 10)) : 0;
    
        return {
            percentComplete: percentComplete,
            buffer: buffer,
            message: title ? 
                        `${title}: ${item?.notificationMsg.statusMessage}` :
                        item?.notificationMsg.statusMessage
        }
    }

    const progressItems = progressState.items.filter(o => o.notificationMsg.temporary === showTemporary);
    const show = progressItems.length > 0;
    //const show = progressState.items.length > 0;

    return (
        <Fade in={show}  
            // sx={{
            //     display: "flex",
            //     flexDirection: "column",
            //     flex: '1 1 auto',
            //     overflow: "hidden"}}
            >
            <AppBar position="static" color='default'>

                {progressItems.map((o, index) => {
                    const data = getData(o);
                    return (
                        <React.Fragment key={index}>
                            <Box sx={{ display: 'flex', 
                                alignItems: 'center', 
                                mt: 1,
                                pl: 2,
                                pr: 2,
                                }}>

                                    <Box sx={{ width: '100%', mr: 1 }}>
                                        {/* <LinearProgress variant="determinate" color="secondary" value={percentComplete} /> */}
                                        <LinearProgress variant="buffer" color="secondary" value={data.percentComplete} valueBuffer={data.buffer} />
                                    </Box>
                                    <Box sx={{ minWidth: 35 }}>
                                        <Typography variant="body2" sx={{
                                            color: "text.secondary"
                                        }}>
                                            {`${data.percentComplete}%`}
                                        </Typography>
                                    </Box>
                                </Box>
                            <Box sx={{ display: 'flex', 
                            justifyContent: 'center', 
                            pl: 2,
                            pr: 2
                            }}>
                            <Box>
                                <Typography variant="body2" sx={{
                                    color: "text.secondary"
                                }}>
                                    {
                                        data.message
                                    }
                                </Typography>
                            </Box>
                        </Box>
                        </React.Fragment>
                    );

                })}

            </AppBar>
        </Fade>
    );
}

